import m from 'mithril'

import InstallBapp from '../components/install-bapp'
import ModifyAccess from '../components/modify-access'

var isForGrant = window.location.search.indexOf('oauth=1') >= 0

m.mount(document.getElementById('app'), {
  view: () =>
    m('.fullscreen',
      m(OAUTH_DATA.client.id === 'new' ? InstallBapp : ModifyAccess, {
        user: OAUTH_DATA.user,
        scope: OAUTH_DATA.scope,
        client: OAUTH_DATA.client,
        transactionID: OAUTH_DATA.transactionID,
      })
    )
})
